export default __webpack_public_path__ + "static/media/1714e9409111e76789962ee72f2ee7991581617658206.3c8ff8fd.webp";